// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_np-5";
export var filledCircle = "_np-4";
export var historyEntry = "_np-3";
export var messageSideLeft = "_np-1";
export var messageSideRight = "_np-2";
export var orderTrackingCarouselWrapper = "_np-6";
export var orderTrackingInfoContainer = "_np-0";